import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';
import { EquipamientoExViewModel, TProductoSolicitudExViewModel } from '../productos/productosEx.types';
import { TReexportacionViewModel } from '../reexportacion/reexportacion.types';
import { TComentarioInspectorExViewModel } from '../seguimiento/seguimientoEx.types';

export class TInspeccionExViewModel {
    public IdSolicitudEx: number;
    public Documental: boolean | null;
    public SeEfectuaIdentidadFisica: boolean;
    public Identidad: boolean | null;
    public Fisica: boolean | null;
    public IdUsuarioDocumental: number;
    public IdUsuarioIdentidad: number;
    public IdUsuarioFisica: number;
    public Observaciones = '';
    public IdDecision: number | null;
    public FechaDocumental: Date | null;
    public FechaIdentidad: Date | null;
    public FechaFisica: Date | null;
    //public FechaLlegada: Date;
    public FechaFinalizacion: Date | null;
    public IdEstadoSolicitudEx: number;
    public IdTipoSolicitudEx: number;
    public IdTipoPuntoInspeccion: number;
    public EsPrevia: boolean;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdTipoSolicitudExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public TTratamientoDesinfeccionEx: TTratamientoDesinfeccionExViewModel;
    public TReexportacionEx: TReexportacionViewModel;
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
    public TSolicitudEquipamientoExCollection: EquipamientoExViewModel[];
    public TProductoSolicitudExCollection: TProductoSolicitudExViewModel[];
    public TComentarioInspectorExCollection: TComentarioInspectorExViewModel[];
    public IdUsuarioDocumentalDescripcion: string;
    public IdUsuarioIdentidadDescripcion: string;
    public IdUsuarioFisicaDescripcion: string;
    //public IdMedidaRechazo: number | null;
    //public IdMotivoRechazo: number | null;
    //public IdAlcanceRechazo: number | null;
    //public IdDetalleMotivoRechazo: number | null;
    //public IdElementoRechazo: number | null;
    //public TwInspeccionRechazo: TwInspeccionRechazoViewModel;
    //public TSolicitudMedidaRechazoCollection: TwSolicitudMedidaRechazoViewModel[];
    //public TSolicitudMotivoRechazoCollection: TwSolicitudMotivoRechazoViewModel[];
}

export class TTratamientoDesinfeccionExViewModel {
    public IdSolicitudEx: number;
    public Tratamiento: string;
    public ProductoQuimico: string;
    public Concentracion: string;
    public Duracion: string;
    public Temperatura: string;
    public InformacionAdicional: string;
    public Fecha: Date | null;
}

//export class TwInspeccionRechazoViewModel {
//    public IdSolicitud: number;
//    public FechaRechazo: Date| null;
//    public IdDestinoControl: number | null;
//    public TwDestinoControl: DestinoControlViewModel;
//}

//export class TwSolicitudMedidaRechazoViewModel {
//    public Id: number;
//    public IdSolicitud: number;
//    public IdMedidaRechazo: number;
//    public IdAlcanceRechazo: number;
//    public IdMedidaRechazoDescripcion: string;
//    public IdAlcanceRechazoDescripcion: string;
//}
//export class TwSolicitudMotivoRechazoViewModel {
//    public Id: number;
//    public IdSolicitud: number;
//    public IdMotivoRechazo: number;
//    public IdDetalleMotivoRechazo: number;
//    public IdElementoRechazo: number;
//    public IdMotivoRechazoDescripcion: string;
//    public IdDetalleMotivoRechazoDescripcion: string;
//    public IdElementoRechazoDescripcion: string;
//}

export class TwSolicitudFrExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public IdContadorFrEx: number;
    public Frecuencia: number;
    public PorcentajePif: number;
    public PorcentajeNacional: number;
    public TotalPif: number;
    public TotalConFisicaPif: number;
    public TotalNacional: number;
    public TotalConFisicaNacional: number;
    public GrupoFrDescripcion: string;
}


/*ViewModel de la reasignacion del Pcf */
export class ReasignacionPcfViewModel {
    public IdPuntoInspeccion: number;
    public IdUbicacion: number;
    public IdInstalacionAutorizada: number;
    public IdIntervaloHoras: number;
    public IdSolicitudEx: number;
}
